/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilitiesPatchInput } from '../../models/availabilities-patch-input';
import { AvailabilitiesPatchResponse } from '../../models/availabilities-patch-response';

export interface AvailabilitiesPatch$Params {
  'Active-Tenant-Identifier': string;
  AvailabilitiesPatchInput: Array<AvailabilitiesPatchInput>;
  integrations?: any;
}

export function availabilitiesPatch(http: HttpClient, rootUrl: string, params: AvailabilitiesPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilitiesPatchResponse>> {
  const rb = new RequestBuilder(rootUrl, availabilitiesPatch.PATH, 'patch');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.AvailabilitiesPatchInput, 'application/json');
    rb.query('integrations', params.integrations, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AvailabilitiesPatchResponse>;
    })
  );
}

availabilitiesPatch.PATH = '/availabilities';
